import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy, OnInit,
    Output,
    Renderer2,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {FileUploadService} from "../../services/file-upload.service";
import {HttpHeaders, HttpResponse} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {SessionService} from "../../../session/session.service";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {debounceTime, finalize} from "rxjs/operators";
import {ObjViewerService} from "../../../services/obj-viewer.service";
import {extraerImagenesDeZip, ZipImagenesError} from "../../services/zip-imagenes";

@Component({
    selector: 'be-file-upload2',
    templateUrl: './file-upload.component2.html',
    styleUrls: ['./file-upload.component2.scss']
})
export class FileUploadComponent2 implements OnInit, AfterViewInit, OnDestroy, OnChanges {

    progress = 0;
    progressType = '';
    message = '';
    isArray = false;

    private removeSubscription = new BehaviorSubject<boolean>(false);
    private subscriptions: Subscription[] = [];

    @ViewChild('objViewer') objViewer: ElementRef;
    @ViewChild('lineaArchivo') lineaArchivo: ElementRef;
    @Input() buttonName = '';
    @Input() listaArchivos: any[] = [];
    @Output() public fileUploadedEmmiter = new EventEmitter<any[]>();
    @Output() public fileRemovedEmitter = new EventEmitter<any>();
    @Output() public seleccionEmmiter = new EventEmitter<any>();
    @Input() mostrarVisor = true;
    @Input() seleccionarPrimero = true;
    @Input() archivoSeleccionado: any = null;
    @Input() archivoSiguiente: any = null;
    @Input() disableButton = false;
    @Input() modelType = null;
    @Input() parentModelType = null;
    @Input() actualizarVisor = new BehaviorSubject<boolean>(false);
    /**
     * Zona de intraorales: un ZIP se sube entero, como hasta ahora, y además las imágenes que lleve dentro, como si se
     * hubieran subido sueltas (ver zip-imagenes.ts).
     */
    @Input() extraerImagenesZip = false;
    private destruido = false;
    /** Por qué no se han subido las imágenes de un ZIP. Aparte de `message`, que cada subida vacía al empezar. */
    avisoZip = '';
    private clicked = new Subject<any>();
    private urlFile = environment.uploaderUrl;
    seleccionando = false;
    @Input() tiposArchivoSoportados: string[] = ['*'];
    archivosSoportados: string = '';
    /** Archivos con el DELETE en marcha: un segundo clic no lanza otro */
    private borrando?: Set<any>;

    constructor(private uploadService: FileUploadService, private sessionService: SessionService, private interfaceProvider: InterfaceProviderService,
                private readonly _objViewerService: ObjViewerService, private readonly _renderer: Renderer2) {

        let params = new HttpHeaders();
        params = params.append('Authorization', 'Bearer ' + sessionService.token.token);
        this.uploadService.setBaseUrl(this.urlFile);
        this.uploadService.setRequestHeaders(params);
        this.uploadService.progressCompressObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Comprimido';
        });
        this.uploadService.progressUploadObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Subido';
        });
        this.removeSubscription.subscribe(result => {
            if (result) {
                this.subscriptions.forEach(sus => sus.unsubscribe());
            }
        })
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        if (this.tiposArchivoSoportados && this.tiposArchivoSoportados.length > 0) {
            this.archivosSoportados = this.tiposArchivoSoportados.join(',');
            this.archivosSoportados += this.tiposArchivoSoportados.map(a => a.toUpperCase()).join(',');
        }

        if (this.mostrarVisor) {
            // this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);
            // setTimeout(() => {
            //     this.seleccionar(this.archivoSeleccionado)
            // }, 500);
            //
            this.actualizarVisor.subscribe(actualizar => {
                // if (actualizar && !this._objViewerService.escenaIniciada()) {
                //     setTimeout(() => {
                //         this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);
                //         this.seleccionar(this.archivoSeleccionado);
                //     }, 500);
                // } else if (this.archivoSeleccionado) {
                //     console.log('aquiiiiiiiiii')
                //     const url = this.urlFile + '/' + this.archivoSeleccionado.id + '/descargar';
                //     if (this.mostrarVisor) {
                //         this._objViewerService.loadObj(url, this.archivoSeleccionado.nombreFichero);
                //     }
                //     this.seleccionEmmiter.next(this.archivoSeleccionado);
                // }

                if (actualizar) {
                    this.seleccionar(this.archivoSeleccionado);
                }
            })
        }


        // Para evitar el doble click en el objeto
        const buttonClickedDebounced = this.clicked.pipe(debounceTime(350));
        buttonClickedDebounced.subscribe((archivo: any) => this.seleccionar(archivo));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disableButton) {
            this.disableButton = changes.disableButton.currentValue;
        }

        // if (changes.archivoSeleccionado && (changes.archivoSeleccionado.previousValue !== changes.archivoSeleccionado.currentValue && changes.archivoSeleccionado.currentValue !== undefined)) {
        //     this.actualizarVisor.next(true);
        // }
        //
        // if (changes.listaArchivos && changes.listaArchivos.currentValue && changes.listaArchivos.currentValue.length === 0 && this.objViewer) {
        //     this._objViewerService.limpiarObj();
        // }

        if (changes.modelType && changes.modelType.currentValue && changes.modelType.currentValue !== changes.modelType.previousValue) {
            this.modelType = changes.modelType.currentValue;
            this.urlFile = this.modelType ? environment.apiUrl + '/' + this.interfaceProvider.interfaceForModel(this.modelType).endpoint : environment.uploaderUrl;
            this.uploadService.setBaseUrl(this.urlFile);
        }
    }

    ngOnDestroy(): void {
        this.destruido = true;
        this._objViewerService.limpiarEscena();
        this.subscriptions.forEach(sus => sus.unsubscribe());
    }

    selectFile(event: any): void {
        this.seleccionando = true;
        if (event.target.files && event.target.files.length === 1) {
            const file: File = event.target.files[0];
            this.subirArchivo(file);
        } else if (event.target.files.length > 1) {
            const fileListAsArray = Array.from(event.target.files);
            fileListAsArray.forEach((ar: File) => this.subirArchivo(ar));
        }
    }

    /** El archivo tal cual y, si es un ZIP y la zona lo pide, también sus imágenes */
    private subirArchivo(file: File): void {
        this.upload(file, this.parentModelType);
        if (this.extraerImagenesZip && file && file.name.toLowerCase().endsWith('.zip')) {
            this.subirImagenesDelZip(file);
        }
    }

    subirImagenesDelZip(zipFile: File): Promise<void> {
        this.avisoZip = '';
        return extraerImagenesDeZip(zipFile)
            .then(imagenes => {
                // Si ya se ha salido de la pantalla, subirlas dejaría archivos sin solicitud
                if (!this.destruido) {
                    imagenes.forEach(imagen => this.upload(imagen, this.parentModelType));
                }
            })
            .catch(error => {
                this.avisoZip = error instanceof ZipImagenesError ? error.message : 'No se han podido sacar las imágenes del ZIP.';
            });
    }

    upload(file: File, type: any): void {
        this.progress = 0;
        let files = [];
        this.message = "";
        if (file) {
            this.subscriptions.push(this.uploadService.upload(file, type).pipe(finalize(() => {
                this.listaArchivos.push(...files);
                this.seleccionar(this.listaArchivos[this.listaArchivos.length - 1]);
            })).subscribe(
                (event: any) => {
                    if (event instanceof HttpResponse) {
                        if (Array.isArray(event.body)) {
                            files = event.body.map(file => {
                                this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(file)
                            });
                        } else {
                            files.push(this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(event.body));
                        }
                        this.seleccionando = false;
                    }
                },
                (err: any) => {
                    this.progress = 0;
                    if (err.error && err.error.message) {
                        this.message = err.error.message;
                    } else if (err.error && err.error['hydra:description']) {
                        this.message = err.error['hydra:description'];
                    } else {
                        this.message = 'No se ha podido subir el archivo!';
                    }

                    this.seleccionando = false;
                }));
        }
    }


    dropEvent(event: DragEvent) {
        event.preventDefault();
        this.progress = 1;
        const items = event.dataTransfer.items;
        this.uploadService.proccessDropEventFiles(items).subscribe(file => this.subirArchivo(file));
    }

    onDragOver(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
    }


    update(archivos: any[]) {
        this.listaArchivos.push(...archivos);
    }

    /**
     * Al padre se le avisa (fileRemovedEmitter) y la lista cambia solo cuando el DELETE ha ido bien: antes se avisaba
     * en el mismo clic aunque el DELETE fallara. Un 404 es un error más: también puede ser falta de permiso.
     */
    borrar(archivo: any, i) {
        const enCurso = this.borrando ??= new Set<any>();
        if (enCurso.has(archivo)) {
            return;
        }
        enCurso.add(archivo);
        this.uploadService.remove(archivo).pipe(finalize(() => enCurso.delete(archivo))).subscribe(() => {
            this.fileRemovedEmitter.emit(archivo);
            const indice = this.listaArchivos.indexOf(archivo);
            if (indice >= 0) {
                this.listaArchivos.splice(indice, 1);
                if (this.mostrarVisor) {
                    // El siguiente, el anterior si se ha borrado el último, o null si no queda ninguno (seleccionar()
                    // se llama igual: es lo que avisa al padre con la lista ya sin el archivo)
                    this.seleccionar(this.listaArchivos[Math.min(indice, this.listaArchivos.length - 1)] ?? null);
                }
            }
        }, () => {
            // El aviso ya lo da ApiService (catchError → ErrorDisplayService); aquí solo no se da por borrado
        });
    }

    /** Quita de la lista solo los que se han borrado; los que fallan se quedan (el aviso lo da ApiService). */
    borrarTodos() {
        let pendientes = this.listaArchivos.length;
        [...this.listaArchivos].forEach(archivo => this.uploadService.remove(archivo).pipe(finalize(() => {
            if (--pendientes === 0) {
                this.seleccionar(this.listaArchivos.length > 0 ? this.listaArchivos[0] : null);
            }
        })).subscribe(() => {
            const indice = this.listaArchivos.indexOf(archivo);
            if (indice >= 0) {
                this.listaArchivos.splice(indice, 1);
            }
        }, () => undefined));
    }

    click(archivo?: any) {
        this.archivoSiguiente = archivo;
        this.clicked.next(archivo)
    }

    seleccionar(archivo?: any) {
        // if (archivo && this.seleccionarPrimero) {
        //     this.archivoSeleccionado = archivo;
        //     const url = this.urlFile + '/' + archivo.id + '/descargar';
        //     if (this.mostrarVisor) {
        //         this._objViewerService.loadObj(url, archivo.nombreFichero);
        //     }
        // } else {
        //     this.archivoSeleccionado = null;
        // }

        // Con [mostrarVisor]="false" no existe #objViewer: tocarlo lanzaba un TypeError antes de avisar al
        // padre, y el archivo recién subido no se enganchaba a la solicitud.
        if (this.mostrarVisor && this.objViewer && archivo) {
            this._objViewerService.iniciarEscenaSiNoIniciada(this._renderer, this.objViewer.nativeElement);
            const url = this.urlFile + '/' + archivo.id + '/descargar';
            setTimeout(() => this._objViewerService.loadObj(url, archivo.nombreFichero), 500);
        }

        this.fileUploadedEmmiter.next(this.listaArchivos)
        setTimeout(() => this.seleccionEmmiter.next(archivo), 300);
        this.archivoSiguiente = null;
    }

    nombreFichero(archivo: any) {
        return archivo ? archivo.nombreFichero : '';
    }
}
